// ── Number formatters ──────────────────────────────────────────────────────────
export function fmt(n: number, dec = 0): string {
  return n.toLocaleString('es-ES', { maximumFractionDigits: dec })
}

/** Unidades enteras con separador de millar. Siempre el número completo:
 *  10.500, nunca «10,5k» — en planta se comparan cantidades exactas. */
export function fmtUds(n: number): string {
  return Math.round(n).toLocaleString('es-ES')
}

export function pct(val: number, total: number): number {
  if (!total) return 0
  return Math.min(100, Math.max(0, Math.round((val / total) * 100)))
}

// ── Date parser ────────────────────────────────────────────────────────────────
export function parseDate(s: string | undefined | null): Date | null {
  if (!s) return null
  const d = new Date(s.includes('T') ? s : s + 'T00:00:00')
  return isNaN(d.getTime()) ? null : d
}

// ── Date labels (static Spanish fallbacks — prefer Intl helpers below) ─────────
export const MON_S    = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']
export const MON_FULL = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
export const DAY_S    = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom']

// ── Locale-aware date label helpers ────────────────────────────────────────────
/** Short month name from a Date using the active locale, e.g. "ene", "Jan", "gen" */
export function getLocaleMonthShort(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { month: 'short' }).replace(/\.$/, '')
}

/** Full month name from a Date using the active locale, e.g. "Enero", "January", "Gener" */
export function getLocaleMonthFull(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { month: 'long' })
}

/** Short weekday name from a Date using the active locale, e.g. "lun.", "Mon", "dl." */
export function getLocaleDayShort(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { weekday: 'short' }).replace(/\.$/, '')
}

/** Format a date as "D mon YYYY" using the active locale */
export function fmtDateLocale(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
}

/** Format a date as "D mon" (no year) using the active locale */
export function fmtDateShortLocale(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' }).replace(/\.$/, '')
}

// ── Production status definitions ─────────────────────────────────────────────
export type SDef = { label: string; dot: string; badge: string; bar: string }

export const STATUS_DEF: Record<number, SDef> = {
  0: { label:'Creado',     dot:'bg-gray-300',    badge:'bg-gray-100 text-gray-500 border-gray-200',         bar:'bg-gray-400'     },
  1: { label:'Estimado',   dot:'bg-slate-400',   badge:'bg-slate-100 text-slate-600 border-slate-200',      bar:'bg-slate-400'    },
  2: { label:'Programado', dot:'bg-yellow-400',  badge:'bg-yellow-50 text-yellow-700 border-yellow-200',    bar:'bg-yellow-400'   },
  3: { label:'Liberado',   dot:'bg-sky-400',     badge:'bg-sky-50 text-sky-700 border-sky-200',             bar:'bg-sky-400'      },
  4: { label:'Iniciado',   dot:'bg-emerald-400', badge:'bg-emerald-50 text-emerald-700 border-emerald-200', bar:'bg-emerald-400'  },
  5: { label:'Notificado', dot:'bg-violet-400',  badge:'bg-violet-50 text-violet-700 border-violet-200',    bar:'bg-violet-400'   },
}

export const sd = (s: number): SDef => STATUS_DEF[s] ?? STATUS_DEF[0]
